import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type LayoutElements = {
  container: SxProps
  content: SxProps
  toolbar: SxProps
  snackbar: SxProps
}

export const layoutStyles: LayoutElements = {
  container: {
    width: '100%',
    height: '100vh',

    '&.noScroll': {
      height: 'unset',
      flex: '1 0 auto'
    }
  },

  content: {
    width: '100%',
    padding: theme.spacing(0, 4, 4, 4),
    marginTop: '66px',
    overflowY: 'auto',

    '&.noScroll': {
      overflowY: 'hidden'
    }
  },

  toolbar: {
    ...theme.mixins.toolbar,
    minHeight: 76,

    '@media (min-width: 0px)': {
      minHeight: 76
    },

    '@media (min-width: 600px)': {
      minHeight: 76
    }
  },

  snackbar: {
    position: 'absolute',
    height: '50px!important',
    top: '106px',
    width: 'calc(100% - 313px)',
    zIndex: 2,
    marginLeft: '281px'
  }
}
